import React from 'react';

// Custom Nodes
import StartNode from '../../components/nodes/StartNode';
import CapabilityNode from '../../components/nodes/CapabilityNode';
import ConditionNode from '../../components/nodes/ConditionNode';
import RouterNode from '../../components/nodes/RouterNode';
import ActionNode from '../../components/nodes/ActionNode';
import EndNode from '../../components/nodes/EndNode';

// Custom Edges
import DeletableEdge from '../../components/edges/DeletableEdge';

// =============================================================================
// NODE TYPES REGISTRY
// =============================================================================

export const nodeTypes = {
  start: StartNode,
  capability: CapabilityNode,
  condition: (props) => {
    if (props.data?.key === 'intent_router') {
      return <RouterNode {...props} />;
    }
    return <ConditionNode {...props} />;
  },
  action: ActionNode,
  end: EndNode,
};

// =============================================================================
// EDGE TYPES REGISTRY
// =============================================================================
export const edgeTypes = {
  deletable: DeletableEdge,
};
